import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Grid } from "@mui/material";
import blackLogo from "../../../../images/es_lg_full_black.svg";
import * as React from "react";
export const ClientTopBar = () => {
    return (_jsx(Grid, { className: "logocontainer", children: _jsx(Box, { className: "logo", component: "img", src: blackLogo }) }));
};
